import { QSET_REVIEW_TASK_DETAIL_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { WorkflowRole } from '@exam-management/common/types';
import { NavigateBackLink, QSetReviewStatusTag } from '@exam-management/components';
import { Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';
import { matchPath, useLocation } from 'react-router-dom';

import { useQSetReviewTask } from '../../providers';

export default function MainTaskPageHeader() {
  const { mainTaskDetail } = useQSetReviewTask();
  const { assignedRoles } = useQSetReviewTask();
  const isTaskOwner = assignedRoles.includes(WorkflowRole.TASK_OWNER);
  const isLeadReviewer = assignedRoles.includes(WorkflowRole.TASK_ASSIGNEE);

  const isVisibleMainTaskStatus = isTaskOwner || isLeadReviewer;

  const { name, code, updatedAt, currentWorkflowStep } = mainTaskDetail;
  const location = useLocation();
  const matchedTaskManagement = matchPath('/task-management/*', location.pathname);
  return (
    <PageHeader
      title={name}
      linkAdornment={
        <NavigateBackLink
          to={matchedTaskManagement ? '/task-management/qset-review' : '/'}
          replace
        />
      }
      endAdornment={
        isVisibleMainTaskStatus ? (
          <QSetReviewStatusTag
            status={currentWorkflowStep.code}
            data-testid={QSET_REVIEW_TASK_DETAIL_DATA_TEST_ID.STATUS_TAG}
          />
        ) : null
      }
      subtitleSection={
        <Flex
          sx={{
            width: '100%',
            justifyContent: 'space-between',
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          <Text variant='body2'>Task ID: {code}</Text>
          {isVisibleMainTaskStatus ? (
            <Text variant='body2'>Last Modified: {formatDateTime(updatedAt)}</Text>
          ) : null}
        </Flex>
      }
    />
  );
}
